<template>
  <v-card outlined class="pa-4">
    <div class="d-flex align-center justify-space-between mb-3">
      <div class="text-h6">Activité des exécutions</div>

      <div class="d-flex align-center legend">
        <div class="legend-item">
          <span class="legend-box square-green"></span>
          <span>Rapide</span>
        </div>
        <div class="legend-item">
          <span class="legend-box square-orange"></span>
          <span>Moyenne</span>
        </div>
        <div class="legend-item">
          <span class="legend-box square-red"></span>
          <span>Lente</span>
        </div>
        <div class="legend-item">
          <span class="legend-box square-gray"></span>
          <span>En attente</span>
        </div>
      </div>
    </div>

    <div class="mb-3 d-flex flex-wrap stats">
      <div class="mr-4"><strong>Total :</strong> {{ items.length  }}</div>
      <div class="mr-4"><strong>Vert :</strong> {{ greenCount  }} ({{ getPercent(greenCount) }} %)</div>
      <div class="mr-4"><strong>Orange :</strong> {{ orangeCount }} ({{ getPercent(orangeCount) }} %)</div>
      <div class="mr-4"><strong>Rouge :</strong> {{ redCount }} ({{ getPercent(redCount) }} %)</div>
   
    </div>

    <div class="activity-grid">
      <v-tooltip
        v-for="item in normalizedItems"
        :key="item.id"
        top
      >
        <template v-slot:activator="{ on, attrs }">
          <div
            v-bind="attrs"
            v-on="on"
            class="activity-square"
            :class="squareClass(item)"
          ></div>
        </template>

        <div>
          <div><strong>ID:</strong> {{ item.id }}</div>
          <div><strong>SERVICE:</strong> {{ item.bill_info.service }}</div>
          <div><strong>Créé le:</strong> {{ formatDate(item.created_at) }}</div>
          <div><strong>Mis à jour:</strong> {{ item.updated_at ? formatDate(item.updated_at) : '-' }}</div>
          <div><strong>Délai:</strong> {{ getDiff(item.created_at, item.updated_at) }}</div>
          <div><strong>État:</strong> {{ getStateLabel(item) }}</div>
        </div>
      </v-tooltip>
    </div>
  </v-card>
</template>

<script>
import moment from 'moment'

export default {
  name: 'ExecutionActivityWidget',

  props: {
    items: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    normalizedItems() {
      return [...this.items].sort((a, b) => {
        return moment(b.created_at).valueOf() - moment(a.created_at).valueOf()
      })
    },

    greenCount() {
      return this.items.filter(item => this.getState(item) === 'green').length
    },

    orangeCount() {
      return this.items.filter(item => this.getState(item) === 'orange').length
    },

    redCount() {
      return this.items.filter(item => this.getState(item) === 'red').length
    },

    grayCount() {
      return this.items.filter(item => this.getState(item) === 'gray').length
    }
  },

  methods: {
    formatDate(date) {
      return date ? moment(date).format('DD/MM/YYYY HH:mm:ss') : '-'
    },
      getPercent(count) {
    if (!this.items.length) return 0
    return ((count / this.items.length) * 100).toFixed(1)
  },

    getDiffInSeconds(startDate, endDate) {
      if (!startDate || !endDate) return null
      return moment(endDate).diff(moment(startDate), 'seconds')
    },

    getDiff(startDate, endDate) {
      if (!startDate || !endDate) return 'En attente'

      const diffInSeconds = this.getDiffInSeconds(startDate, endDate)
      const minutes = Math.floor(diffInSeconds / 60)
      const seconds = diffInSeconds % 60

      return `${minutes} min ${seconds} sec`
    },

    getState(item) {
      if (!item.updated_at) return 'gray'

      const diffInSeconds = this.getDiffInSeconds(item.created_at, item.updated_at)

      if (diffInSeconds < 240) return 'green'
      if (diffInSeconds <= 600) return 'orange'
      return 'red'
    },

    getStateLabel(item) {
      const state = this.getState(item)

      if (state === 'green') return 'Rapide'
      if (state === 'orange') return 'Moyenne'
      if (state === 'red') return 'Lente'
      return 'En attente'
    },

    squareClass(item) {
      const state = this.getState(item)

      if (state === 'green') return 'square-green'
      if (state === 'orange') return 'square-orange'
      if (state === 'red') return 'square-red'
      return 'square-gray'
    }
  }
}
</script>

<style scoped>
.activity-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(16px, 16px));
  gap: 6px;
}

.activity-square {
  width: 16px;
  height: 16px;
  border-radius: 3px;
  cursor: pointer;
  transition: transform 0.15s ease, opacity 0.15s ease;
}

.activity-square:hover {
  transform: scale(1.15);
}

.square-green {
  background-color: #16a34a;
}

.square-orange {
  background-color: #f59e0b;
}

.square-red {
  background-color: #dc2626;
}

.square-gray {
  background-color: #cbd5e1;
}

.legend {
  gap: 12px;
  flex-wrap: wrap;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
}

.legend-box {
  width: 12px;
  height: 12px;
  border-radius: 2px;
  display: inline-block;
}

.stats {
  font-size: 13px;
}
</style>